import { Link } from '@/shared/components/atoms/Link';
import { Divider } from '@/shared/components/Divider';
import { isLiquidityProvisionApp } from '@/shared/featureFlags';
import SparklesIcon from '@/shared/icons/flip-ui-kit/small/Sparkles';
import { apyToText } from '@/shared/utils/boost';
import { formatWithNumeral } from '@/shared/utils/numbers';

export type RewardsTooltipProps = {
  seasonIndex: number;
  baseApy: number;
  rewardsApy: number;
  dailyPoints: number;
};

export default function SupplyRewardsTooltip({
  seasonIndex,
  baseApy: supplyApy,
  rewardsApy,
  dailyPoints,
}: RewardsTooltipProps) {
  return (
    <div className="flex w-[306px] flex-col gap-y-3 bg-cf-gray-3-5 p-2 text-12">
      <div className="font-aeonikMedium text-14 text-cf-white">
        Earn{' '}
        {isLiquidityProvisionApp ? (
          <Link href="/rewards" className="text-cf-white underline" noPropagate>
            Season {seasonIndex}
          </Link>
        ) : (
          `Season ${seasonIndex}`
        )}{' '}
        Rewards
      </div>
      <Divider className="h-px" />
      <div className="flex items-center gap-x-2">
        <div className="rounded-[4.8px] bg-gradient-to-b from-[#46DA93] to-[#89F399] p-1 shadow-[0_2.186px_0.546px_0_rgba(123,168,0,0.01),0_1.366px_0.546px_0_rgba(123,168,0,0.07),0_0.82px_0.546px_0_rgba(123,168,0,0.24),0_0.273px_0.273px_0_rgba(123,168,0,0.42),0_0_0.273px_0_rgba(123,168,0,0.48)]">
          <SparklesIcon className="text-black" />
        </div>
        <div className="flex flex-col justify-between font-aeonikMedium">
          <div className="text-12 text-cf-white">Points Distributed</div>
          <div className="text-12 text-cf-light-2">
            {formatWithNumeral(dailyPoints, false, true)} Daily
          </div>
        </div>
      </div>
      <Divider className="h-px" />
      <div className="leading-[16px] text-cf-light-2">
        Rewards are accrued through usage and are distributed at regular intervals. The expected
        value of rewards may fluctuate over time depending on usage and participation.
      </div>
      <Link
        href="https://blog.chainflip.io/chainflip-lending-closed-beta/"
        color="green"
        target="_blank"
      >
        Learn more
      </Link>
      <Divider className="h-px" />
      <div className="flex flex-col gap-y-1 font-aeonikMedium text-cf-white">
        <div className="flex items-center justify-between">
          Supply APY
          <div className="text-16">{apyToText(supplyApy)}</div>
        </div>
        <div className="flex items-center justify-between">
          Rewards
          <div className="text-16 text-cf-green-1">{apyToText(rewardsApy)}</div>
        </div>
        <Divider className="h-px pt-1" />
      </div>
      <div className="flex items-center justify-between font-aeonikMedium text-cf-white">
        Total Combined APY
        <div className="text-16">{apyToText(supplyApy + rewardsApy)}</div>
      </div>
    </div>
  );
}
